import type { PrintSettings as ReceiptSettings } from "./types/print-setting";

let hotel: any = {};
try {
    const hotelStr = localStorage.getItem("hotel");
    if (hotelStr) hotel = JSON.parse(hotelStr);
} catch (e) {
    console.warn("Invalid hotel data in localStorage:", e);
    hotel = {};
}

export const DEFAULT_PRINT_SETTINGS: ReceiptSettings = {
    printerType: "A4",
    orientation: "portrait",
    includeDuplicate: true,
    defaultCopies: 1,
    paperWidth: "58mm",
    showLogo: true,
    // showVat: false,
    includeAddress: true,
    showFooterNote: true,
    footerNote: "Thank you for choosing us!",
    fontSize: "medium",
    displayName: hotel.name,
    receiptLogoUrl: hotel.imagePath,
    showSignature: true,

    // NEW DEFAULT LABELS
    showCustomerCopyLabel: true,
    customerCopyLabel: "--- Customer Copy ---",
    showBusinessCopyLabel: true,
    businessCopyLabel: "--- Business Copy ---",
};

export const PAGINATION_PAGE_NUMBER = 10;
export const DELAY_BEFORE_RELOAD = 500;
export const DELETED_STAFF = "Former Staff";
export const VAT_RATE = 7.5;
export const CAT_RATE = 5;
export const SERVICE_CHARGE_RATE = 10;
export const EARLY_CHECKIN_AMOUNT = 6000;
export const SHORT_TIME_AMOUNT = 6000;
export const LATE_CHECKOUT_AMOUNT = 6000;
export const SHORT_TIME_DURATION = 2;
export const LATE_CHECKOUT_DURATION = 2;
export const COMPANY_NAME = "Williams Court Hotel & Suite"
export const CURRENCY = "NGN";
export const MAXIMUM_LEAVE_ALLOWED = "14";
export const DEFAULT_CUSTOMER_EMAIL = "na@wiventory.com"